import {
   CLIPS_RESELECT_FACETS, CLIPS_LOAD_MORE_FACETS, CLIPS_RESET_FACETS
} from '../../../store/actions';

import { component, getter, state, action } from '../../../decorators';

import get from 'lodash/get';

import Facet from '../../../components/common/facet/facet.vue';

@component({
   components: { Facet }
})
export default class SearchAside {
   @state(state => state.search.facets) facets
   @state(state => state.search.selectedFacets) selectedFacets

   @getter() isMobile
   @getter() isAnyFacetSelected

   @action(CLIPS_RESET_FACETS) resetFacets
   @action(CLIPS_RESELECT_FACETS) onChangeFacet
   @action(CLIPS_LOAD_MORE_FACETS) loadMoreFacet

   moreLoaderForFacet(facet) {
      const type = facet.type;
      return (selected) => this.loadMoreFacet({facet, selected}).then(d => {
         const facet = find(d.facets, { type });
         return get(facet, 'list', []);
      });
   }

   onMouseWheel(e) {
      /** @type {HTMLDivElement} */
      const filters = this.$refs.filters;
      const sh = filters.scrollHeight;
      const st = filters.scrollTop;
      const h = filters.clientHeight;
      const d = e.wheelDelta;
      // eslint-disable-next-line
      if ((st === (sh - h) && d < 0) || (st === 0 && d > 0)) {
         e.preventDefault();
      }
   }

   handleResize() {
      const { filters } = this.$refs;
      if (filters) {
         filters.control();
      }
   }
}
